import React from 'react';
import { Card, Col, Grid, Radio, Row, Space, Typography } from 'antd';
import { CheckOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const DeviceCheckDetails = ({ checkDetails }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;

  return (
    <Card
      title={
        <Space align="start">
          <ClockCircleOutlined style={{ color: '#1890ff', marginTop: '3px' }} />
          <Text strong style={{ fontSize: isMobile ? '14px' : '16px', whiteSpace: 'normal' }}>
            Device Inspection Details
          </Text>
        </Space>
      }
      variant="borderless"
      style={{ background: '#fafafa', borderRadius: '12px' }}
      styles={{
        header: { borderBottom: '1px solid #f0f0f0', padding: isMobile ? '12px 14px' : '16px 24px' },
        body: { padding: isMobile ? '14px' : '24px' },
      }}
    >
      <Row gutter={[16, 16]}>
        {checkDetails.map((detail, index) => (
          <Col xs={24} key={detail.id || index}>
            <Row
              justify="space-between"
              align={isMobile ? 'top' : 'middle'}
              gutter={isMobile ? [0, 10] : [12, 0]}
              style={{ background: '#fff', padding: isMobile ? '12px' : '12px 16px', borderRadius: '8px', border: '1px solid #f0f0f0' }}
            >
              <Col xs={24} sm={18}>
                <Text style={{ fontSize: '14px', color: '#434343' }}>
                  <Text type="secondary" style={{ marginRight: '8px' }}>{index + 1}.</Text>
                  {detail.question}
                </Text>
              </Col>
              <Col xs={24} sm={6}>
                <div style={{ pointerEvents: 'none', display: isMobile ? 'flex' : 'block', justifyContent: 'flex-end' }}>
                  <Radio.Group value={detail.answer} buttonStyle="solid" size="small">
                    <Radio.Button
                      value="Yes"
                      style={{
                        width: isMobile ? '44px' : '50px',
                        textAlign: 'center',
                        borderRadius: '4px 0 0 4px',
                        background: detail.answer === 'Yes' ? '#52c41a' : '#f5f5f5',
                        color: detail.answer === 'Yes' ? '#fff' : '#8c8c8c',
                        borderColor: detail.answer === 'Yes' ? '#52c41a' : '#d9d9d9'
                      }}
                    >
                      <CheckOutlined />
                    </Radio.Button>
                    <Radio.Button
                      value="No"
                      style={{
                        width: isMobile ? '44px' : '50px',
                        textAlign: 'center',
                        borderRadius: '0 4px 4px 0',
                        background: detail.answer === 'No' ? '#ff4d4f' : '#f5f5f5',
                        color: detail.answer === 'No' ? '#fff' : '#8c8c8c',
                        borderColor: detail.answer === 'No' ? '#ff4d4f' : '#d9d9d9'
                      }}
                    >
                      <CloseOutlined />
                    </Radio.Button>
                  </Radio.Group>
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default DeviceCheckDetails;
